import { useSelected, useFocused } from 'slate-react';
import type { RenderElementPropsFor } from '../../../../types';
import type { MentionElement } from '../../types';
import MentionBase from '../mention-base';

export type MentionElementProps = RenderElementPropsFor<MentionElement>;

export default function MentionElementComponent({
  attributes,
  element,
}: MentionElementProps) {
  const selected = useSelected();
  const focused = useFocused();

  return (
    <MentionBase
      selected={selected && focused}
      user={element.user}
      {...attributes}
    ></MentionBase>
  );
}
